import axiosInstance from "../../axios";
import AXIOS_ROUTES from "../../axios/routes";
import {
  ICreateExercisePayload,
  IUpdateExercisePayload,
} from "../../interfaces/store/exercise-interface";

export const getExerciseApi = async (id: string) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.exercises.getExercise}?exerciseId=${id}`
  );
};

export const createExerciseApi = async (data: ICreateExercisePayload) => {
  return await axiosInstance.post(
    AXIOS_ROUTES.exercises.createExercise,
    data.exercise
  );
};

export const updateExerciseApi = async ({
  exerciseId,
  exercise,
}: IUpdateExercisePayload) => {
  return await axiosInstance.put(
    `${AXIOS_ROUTES.exercises.updateExercise}?exerciseId=${exerciseId}`,
    exercise
  );
};

export const deleteExerciseApi = async (exerciseId: string) => {
  return await axiosInstance.delete(
    `${AXIOS_ROUTES.exercises.deleteExercise}?exerciseId=${exerciseId}`
  );
};

export const searchExercisesApi = async (data: any) => {
  return await axiosInstance.post(AXIOS_ROUTES.exercises.search, data);
};

export const getExercisesByIdsApi = async (exercisesIds: string) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.exercises.getExercisesByid}?exercises=${exercisesIds}`
  );
};
